import usersService from "../services/users/index";

export default {
  install(Vue) {
    Vue.prototype.$users = usersService;
  }
};